import classNames from 'classnames/bind';
import React from 'react';

import { Label } from 'reactComponents/Label/Label';

import styles from './ColorSelect.css';

const css = classNames.bind(styles);

export type ColorSelectProps = {
    value: string;
    colors?: string[];
    onChange?(event: any, props: ColorSelectProps): void;
    name: string;
};

export function ColorSelect(props: ColorSelectProps) {
    return (
        <div className={css('root')}>
            {props.colors?.map((color) =>
                colorCheckbox({
                    ...props,
                    color,
                    isSelected: props.value === color,
                    key: color,
                }),
            )}
        </div>
    );
}

function colorCheckbox(
    props: ColorSelectProps & {
        color: string;
        isSelected?: boolean;
        key: string;
    },
) {
    return (
        <label key={props.key} className={css('checkboxLabel')}>
            <input
                hidden
                type="radio"
                name={props.name}
                value={props.color}
                className={css('checkboxInput')}
                checked={props.isSelected}
                onChange={(event) => {
                    props.onChange &&
                        props.onChange(event, { ...props, value: props.color });
                }}
            />
            <Label
                size="small"
                bordered={props.isSelected}
                hoverable
                color={props.color}
            >
                T
            </Label>
        </label>
    );
}

ColorSelect.defaultProps = {
    colors: Label.BASIC_COLORS,
} as Partial<ColorSelectProps>;
